import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'
import * as Sc from './TopNavigation.style'
import NavigationItem from './_components/NavigationItem'

const TopNavigation = ({ items }) => {
  return (
    <Sc.Navigation>
      {items.map((item) => {
        if (typeof item === 'function') {
          const Component = item
          return <Component key={uuidv4()} />
        }
        const { icon, id, menu } = item || {}
        return (
          <Sc.NavigationItem key={id}>
            <NavigationItem icon={icon} id={id} menu={menu} />
          </Sc.NavigationItem>
        )
      })}
    </Sc.Navigation>
  )
}

TopNavigation.defaultProps = {
  items: [],
}
TopNavigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.shape({
        badgeNumber: PropTypes.number,
        disabled: PropTypes.bool,
        element: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
          .isRequired,
        onClick: PropTypes.func,
      }).isRequired,
      id: PropTypes.string.isRequired,
      menu: PropTypes.node,
    })
  ),
}

export default TopNavigation
